import { Clock } from "lucide-react";

const Dot = () => <span className="text-gray-300">·</span>;

export default function ArticleMeta({ category, date, readTime }) {
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2 mb-4 text-xs text-gray-400">
      <span className="inline-flex items-center rounded-full bg-[#9573F7]/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-[#9573F7]">
        {category}
      </span>
      {date && <span className="text-gray-500">{date}</span>}
      <Dot />
      <span className="inline-flex items-center gap-1">
        <Clock className="w-3.5 h-3.5" /> {readTime}
      </span>
    </div>
  );
}
